/**
 * Extracts and formats repo name from MCP name for display
 * @param mcpName - The full MCP name in format: io.github.<username>/<repo-name>
 * @returns Formatted display name with proper capitalization
 */
export function formatMcpName(mcpName: string): string {
  // Extract repo name from format: io.github.<username>/<repo-name>
  const parts = mcpName.split('/')
  if (parts.length < 2) return mcpName

  const repoName = parts[1]
  // Remove dashes and underscores, split into words
  const words = repoName ? repoName.split(/[-_]+/) : []

  // Capitalize each word with special handling for "mcp"
  return words
    .map(word => {
      const lowerWord = word.toLowerCase()
      if (lowerWord === 'mcp') {
        return 'MCP'
      }

      if (lowerWord === 'github') {
        return 'GitHub'
      }

      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    })
    .join(' ')
}
